import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import LandlordDetailsContainer from './containers/landlord-details/landlord-details.container';
import LandlordsListContainer from './containers/landlords-list/landlords-list.container';

export const LandlordModule: React.FC = () => {
  return (
    <Switch>
      <Route
        exact
        path={`${APP_ROUTES.LANDLORD_MODULE.FULL_PATH}/:landlordId`}
        component={LandlordDetailsContainer}
      />
      <Route exact path={APP_ROUTES.LANDLORD_MODULE.FULL_PATH} component={LandlordsListContainer} />
    </Switch>
  );
};
